<section>
  <section class="comment-confirmation">
    <div class="comment-confirmation-company">
      <div class="comment-confirmation-company-name">
        <p>Empresa pagadora</p>
        <h3>{{ entity?.invoice?.debtor?.companyName }}</h3>
      </div>
      <div class="comment-confirmation-company-amount">
        <p>Monto de la factura</p>
        <lib-amount
          color="blue"
          [amount]="entity?.invoice?.netAmount || '0.00'"
        ></lib-amount>
      </div>
    </div>
    <div class="comment-confirmation-detail">
      <div class="comment-confirmation-detail-codes">
        <p>Códigos ({{ getInvoiceCodesCount(entity?.invoice) }})</p>
        <span>{{ getInvoiceCodes(entity?.invoice) }}</span>
      </div>
      <lib-chip-status [status]="entity?.invoice?.status"></lib-chip-status>
    </div>
  </section>
  <div class="comment-confirmation-form">
    <div class="comment-confirmation-input">
      <p class="comment-confirmation-label">Comentario</p>
      <div
        class="comment-confirmation-message"
        [innerHTML]="entity?.message | safeHtml"
      ></div>
    </div>
    <div class="comment-confirmation-separator"></div>
    <div class="comment-confirmation-icon">
      <img src="../../../../../../assets/icons/clip.svg" />
      <span [ngClass]="entity?.file ? 'blue-text' : ''">
        {{ entity?.filename || "Sin adjunto" | capitalizeFirstLetters }}
      </span>
    </div>
  </div>
  <div
    class="comment-confirmation-finalized-card"
    *ngIf="entity?.invoice?.status === 'finalized'"
  >
    <lib-icon icon="info" size="s" color="red"></lib-icon>
    <div class="comment-confirmation-finalized-card-content">
      <p>Es una factura finalizada</p>
      <span>
        Recuerda que estas comunicaciones deben ser bien puntuales y validadas
        con el líder comercial.
      </span>
    </div>
  </div>
</section>
